import { useEffect, useRef } from 'react';

import { useReducedMotion } from '../../presence/useReducedMotion';
import { createLivingSky } from './livingSkyEngine';

/**
 * Canvas layer of the marketing atmosphere: the living star field, constellations, ember motes,
 * and shooting stars. Mounts inside EmberBackground (its parent `.eb-bg` also receives the
 * scroll-parallax CSS vars the engine publishes). Fully static under reduced motion.
 */
export function LivingSky() {
  const ref = useRef<HTMLCanvasElement | null>(null);
  const reduced = useReducedMotion();

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const handle = createLivingSky(canvas, reduced);
    return () => handle.destroy();
  }, [reduced]);

  return <canvas ref={ref} className="eb-bg__sky" aria-hidden />;
}
